import React from "react";
import { Flex } from "@chakra-ui/react";
import { MotionBox } from "ui/chakra-motion";
import { type ProgressTabProps } from "./progress-tab";

export type ProgressBarProps = Pick<ProgressTabProps, "isActive" | "theme" | "progressDuration" | "onProgressEnd">;

export function ProgressBar({ isActive, progressDuration = 5, theme = "light", onProgressEnd }: ProgressBarProps) {
  const progressBar = {
    inactive: {
      width: "0%",
    },
    active: {
      width: "100%",
      transition: {
        duration: progressDuration,
        ease: "linear",
      },
    },
  };

  return (
    <Flex align="center" height="48px" w="100%">
      <Flex height="2px" bg={`brand.border.${theme}`} pos="relative" w="100%">
        {isActive && (
          <MotionBox
            pos="absolute"
            inset={0}
            right="auto"
            bg={theme === "dark" ? "brand.accent.primary" : "new.green.700"}
            variants={progressBar}
            initial="inactive"
            animate="active"
            onAnimationComplete={onProgressEnd}
          />
        )}
      </Flex>
    </Flex>
  );
}
